<template>
<div>
    <b-container>
        <b-row>
            <b-col cols="12">

                <h2 class="heading" v-if="(babyPass > 0 || cosmicPass > 0 || genesisPass > 0)">ALPHA PASS CUT CLAIM</h2>
                <br><br>
                <div v-if="!isapproved && (babyPass > 0 || cosmicPass > 0 || genesisPass > 0)">
                    <br><br><br><br>
                    <button class="button-42" v-if="!loadingTransaction" @click="approveRefund()">Approve Claim</button>
                    <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin-pulse" font-scale="4"></b-icon>
                </div>

                <div v-if="isapproved && (babyPass > 0 || cosmicPass > 0 || genesisPass > 0)">
                    <br><br><br><br>
                    <h2 class="Passes">CUT BALANCE : {{tokenAmount}}</h2>
                    <br><br>
                    <h2 class="Passes">Genesis Pass : {{genesisPass}} - Cosmic Pass : {{cosmicPass}} - Baby Pass : {{babyPass}}</h2>
                    <br><br><br><br>
                    <button class="button-42" v-if="!loadingTransaction" @click="refund()">Claim CUT</button>
                    <b-icon v-if="loadingTransaction" icon="arrow-clockwise" animation="spin-pulse" font-scale="4"></b-icon>
                </div>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import tokenContract from '../../assets/contracts/newCut.json'
import refundContract from '../../assets/contracts/refund.json'
import passContract from '../../assets/contracts/passContract.json'
import Web3 from 'web3';
export default {
    data: function () {
        return {
            walletAddress: '',
            walletBalance: '',
            tokenAmount: 0,

            saleOpen: false,
            isApproved: false,

            web3: '',

            tokenContract: '',
            tokenContractAbi: tokenContract.abi,
            tokenContractAddress: tokenContract.contractAddress,

            refundContract: '',
            refundContractAbi: refundContract.abi,
            refundContractAddress: refundContract.contractAddress,

            passContract: '',
            passContractAbi: passContract.abi,
            passContractAddress: passContract.contractAddress,

            loadingTransaction: false,


            babyPass: 0,
            cosmicPass: 0,
            genesisPass: 0,

            isapproved: false,

        }
    },
    mounted()
    {
        this.LoadEthWallet();
    },
    methods:{
        refund()
        {
            this.loadingTransaction = true;
            this.refundContract.methods.refundCosmicPass().send({from:this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.LoadTokenInfo();
                this.loadingTransaction = false;
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        approveRefund()
        {
            this.loadingTransaction = true;
            this.passContract.methods.setApprovalForAll(this.refundContractAddress, true).send({from:this.walletAddress})
            .on('confirmation', function(confirmationNumber, receipt)
            {
                
            })
            .then(res=>{
                this.LoadTokenInfo();
                this.loadingTransaction = false;
            })
            .catch(err=>{
                this.loadingTransaction = false;
            })
        },
        async chainChange()
        {
            await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{ chainId: '0x1' }], // chainId must be in hexadecimal numbers
                    });
                    this.LoadEthWallet();
        },
        async LoadTokenInfo(){
            this.tokenContract = await new this.web3.eth.Contract(this.tokenContractAbi, this.tokenContractAddress);
            
            this.tokenContract.methods.balanceOf(this.walletAddress).call({})
            .then(res=>{
                this.tokenAmount = this.web3.utils.fromWei(res, 'ether');
            })
            

            this.passContract = await new this.web3.eth.Contract(this.passContractAbi, this.passContractAddress);

            this.passContract.methods.balanceOf(this.walletAddress, 1).call({})
            .then(res=>{
                this.babyPass = res;
            })
            this.passContract.methods.balanceOf(this.walletAddress, 2).call({})
            .then(res=>{
                this.cosmicPass = res;
            })
            this.passContract.methods.balanceOf(this.walletAddress, 3).call({})
            .then(res=>{
                this.genesisPass = res;
            })

            
            this.passContract.methods.isApprovedForAll(this.walletAddress, this.refundContractAddress).call({})
            .then(res=>{
                this.isapproved = res;
            })



            this.refundContract = await new this.web3.eth.Contract(this.refundContractAbi, this.refundContractAddress);


        },
        LoadEthWallet: function(){
            
            if (typeof window.ethereum !== 'undefined') 
                {
                    ethereum.enable();
                    this.web3 = new Web3(this.walletConnect || window.ethereum || new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/1xVMLkEDl6htSmYN7YeFXGvIe07") || Web3.givenProvider);
                    this.web3.eth.net.getNetworkType()
                    .then(network=>{
                        if(network == "main")
                        {
                            this.web3.eth.requestAccounts()
                            .then(acc=>{
                                this.walletAddress = acc[0];
                                this.web3.eth.getBalance(this.walletAddress)
                                .then(balance=>{
                                    this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                                    this.LoadTokenInfo();
                                });
                            })
                            .catch(err=>{
                                console.log(err);
                            })            
                        }
                        else{
                            this.chainChange();
                        }          
                    })
                }

            
        },
    },
    watch: {
          walletAddress: function(val) {
            window.ethereum.on("accountsChanged", accounts => {
              if (accounts.length > 0)
              {
                this.walletAddress = accounts[0];
                this.web3.eth.getBalance(this.walletAddress)
                .then(balance=>{
                  this.walletBalance = this.web3.utils.fromWei(balance, "ether");     
                });
                this.LoadTokenInfo();
              } 
              else 
              {
                this.walletAddress = '';
                this.walletBalance = '';
              }
            })
          },
          walletBalance: function(val)
          {
            window.ethereum.on("balanceChanged", balance => 
            {
              this.walletBalance = balance;
              this.LoadTokenInfo();
            })
            
          },
    },

}
</script>

<style scoped>
.collectImg
{
    width: 100%;
}
.heading
{
    color: white;
}
.Passes
{
    color: white;
    font-size: 2vh;
}

.button-42 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #eca0f2, #d273ed);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  padding: 0 20px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100%;
  z-index: 9;
  border: 0;
  transition: box-shadow .2s;
}

.button-42:hover {
  box-shadow: #b833e8 0 3px 8px;
}
.clabs
{
    width: 100%;
    display: flex !important;
    margin-bottom: 2vh;
    border: 4px solid #5E5DF0
}
</style>


// WEBPACK FOOTER //
// src/components/Store/refund.vue